/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useEffect } from 'react';
import { Box, FlatList, HStack, Skeleton, Spacer, VStack } from 'native-base';

import { devLog, useGetMilestones, useSpringBigStore, useAppSettings, useI18n, fakeItemsArray } from '@springbig/shared';

import CardMilestone, { CardMilestoneSkeleton } from './components/CardMilestone';
import Section from '~/shared/Section';
import Loading from '~/shared/Loading';
import { useAuthorization } from '~/hooks/auth';
import SuspendedMerchantScreen from '~/shared/SuspendedMerchantScreen';
import { NoDataPlaceholder } from '~/shared/NoDataPlaceholder';
import { faTrophy } from '@fortawesome/free-solid-svg-icons';
import { useGeneralStyles } from '~/shared/styles';

const MilestoneScreen = () => {

    const { isLoadingAuth } = useAuthorization();
    const { walletId, member } = useSpringBigStore();

    const {
        refetch,
        data,
        isLoading
    } = useGetMilestones();
    const { t } = useI18n();


    useEffect(() => {
        if (walletId) {
            refetch();
        }
    }, [walletId]);

    const handleMilestone = () => {
        devLog('data', data);

    };

    if (isLoading || isLoadingAuth || !member || !walletId) {
        return <MilestoneSkeleton />;

    }

    if (
        !(data?.milestones as any)?.spend_milestones?.length &&
        !(data?.milestones as any)?.points_milestones?.length &&
        !(data?.milestones as any)?.visits_milestones?.length
    ) {
        return (<NoDataPlaceholder
            title={t('common.milestones_placeholder_title')}
            message={t('common.milestones_placeholder_subtitle')}
            callback={refetch}
            isLoading={isLoading}
            iconName={faTrophy}
        />);
    }

    return (
        <Section flex={1} w={'100%'}>

            {member && member.show_pending_modal &&
                <SuspendedMerchantScreen />
            }
            <Box mb={4}>
                {(data?.milestones as any)?.spend_milestones?.length > 0 && (
                    <Box w={'100%'} mb={4}>
                        {(data.milestones as any).spend_milestones.map((item, index) => {
                            return (
                                <CardMilestone
                                    key={index}
                                    currentValue={(data.milestones as any).lifetime_spend}
                                    goal={parseInt(item.milestone)}
                                    milestone={item}
                                    handleMilestone={handleMilestone}
                                    t={t}
                                    type={'spend'}
                                />
                            );
                        })}
                    </Box>
                )}
                {(data?.milestones as any)?.points_milestones?.length > 0 && (
                    <Box w={'100%'} mb={4}>
                        {(data.milestones as any).points_milestones.map((item, index) => {
                            return (
                                <CardMilestone
                                    key={index}
                                    currentValue={(data.milestones as any).lifetime_points}
                                    goal={parseInt(item.milestone)}
                                    milestone={item}
                                    handleMilestone={handleMilestone}
                                    t={t}
                                    type={'points'}
                                />
                            );
                        })}
                    </Box>
                )}
                {(data?.milestones as any)?.visits_milestones?.length > 0 && (
                    <Box w={'100%'} mb={4}>
                        {(data.milestones as any).visits_milestones.map((item, index) => {
                            return (
                                <CardMilestone
                                    key={index}
                                    currentValue={(data.milestones as any).lifetime_visits}
                                    goal={parseInt(item.milestone)}
                                    milestone={item}
                                    handleMilestone={handleMilestone}
                                    t={t}
                                    type={'visits'}
                                />
                            );
                        })}
                    </Box>
                )}
            </Box>
        </Section>
    );
};

const MilestoneSkeleton = () => {

    return (
        <>
            {fakeItemsArray.map((_, index) => (

                <Box key={index} my={2}>
                    <CardMilestoneSkeleton />
                </Box>
            ))}
        </>
    );
};

export default MilestoneScreen;
